export default "__VITE_ASSET__Inx_pSi2__"